





































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ElTableComp',
  props: {
    tableData: {
      type: Array,
      deafult: () => [],
    },
    showSelection: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    showEditColumn: {
      type: Boolean,
      default: true,
    },
    btnsWidth: {
      type: String,
      default: '',
    },
  },
  setup(prop: any, { emit}) {
    const handleSelectionChange = (row: any): void => {
      emit('selectColumns', row);
    };

    const handleClick = (row: any): void => {
      console.log(row);
    };

    return {
      handleSelectionChange,
      handleClick
    };
  },
});
